export type AlternatePath = {
  href: string
  language: string
}

export type Breadcrumb = {
  id: string
  name: string
  href: string | null
}

export enum Product {
  LuggageStorage = "luggageStorage",
  PackageAcceptance = "PackageAcceptance",
}

export enum PartnerType {
  Partner = "Partner",
  Affiliate = "Affiliate",
}

export type PageType = "AppDownload" | "Cities" | "City" | "Event" | "Home" | "POI" | "Store"
